/* eslint-disable */
import React, { useCallback, useEffect, useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import {FEATURE_TOGGLE_TSPAY} from "../../config";
import {
  fetchAgyoServicesSubscription,
  fetchActiveAccountantService,
  allAgyoServicesSubscription
} from "../../store/actions/services/service-subscription";

import {
  getSettingsCompany,
  getSettingsCompanyForUser
} from "../../store/actions/permissions";

import Header from "../../components/header";
import MessageEmptyCompaniesStudio from "../../components/general/messageEmptyCompaniesStudio";
import TimedOverflow from "../timedOverflow";
import UserVoice from "../../components/general/userVoice";
import RoutesView from "./routes";
import { loadAccounts, loadConfig } from "../../store/actions/tspay";
import { getTsPayConfigStatus } from "../../store/actions/tspay/onboarding";
import { registerDeadlinesPayment } from "../../store/actions/tspay/payment";
import useGetCompanies from "../../customHooks/useGetCompanies";

import "./style.css";
import { useLocation } from "react-router-dom";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";

const Init = props => {
  /** Evita di usare la connect ed è più performante */
  const location = useLocation();
  const dispatchAction = useDispatch();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const company = useSelector(state => state.company);
  const studio = useSelector(state => state.studio);
  const user = useSelector(state => state.user);
  const connection = useSelector(state => state.connections);
  const studioFind = GetSelectedCompanyStudio();
  const {getCompanies} = useGetCompanies();    

  /* Importante per catturare evento di pagamento TSPay completato, è inoltre importante tenerlo qui in root
     per intercettare pagamenti completati anche in caso di spostamenti forzati da parte dell'utente */
  useEffect(() => {
    if (
      auth.loginAuth &&
      main.companyUuidSelected &&
      main.accountantUuidSelected
    ) {
      const handler = event => {
        if (event.data && event.data.transactionUuid) {
          let itemStorage = localStorage.getItem(
            `tspayPaymentUuidToCheck_${event.data.transactionUuid}`
          );
          if (itemStorage) {
            dispatchAction(
              registerDeadlinesPayment(
                JSON.parse(itemStorage).deadlineIds,
                JSON.parse(itemStorage).initDeadlinesPayId
              )
            );
          }
        }
      };

      window.addEventListener("message", handler);

      // clean up
      return () => window.removeEventListener("message", handler);
    }
  }, [auth.loginAuth, main.companyUuidSelected, main.accountantUuidSelected]);

  /** controllo le pagine per il torna indietro */
  useEffect(() => {
    if (location.pathname !== main.prevPathname) {
      dispatchAction({
        type: "setPaths",
        prevPathname: location.pathname,
        /** se sono in dettaglio scadenza non voglio mantenere questa info */
        prevPath: location.pathname.match(/scadenz/g)
          ? main.prevPath
          : location.pathname,
        realPrevPath: main.prevPath
      });
    }
  }, [location.pathname]);

  useEffect(() => {        
    if (
      main.accountantUuidSelected &&
      main.companyUuidSelected &&  (user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id)
    ) {            
      
        main.myType === "STUDIO"
          ? main.accountantUuidSelected
          : main.companyUuidSelected;
      dispatchAction(
        fetchAgyoServicesSubscription(
          auth,
          main.accountantSelected,
          main.clientIdSelected
        )
      );
      if (main.myType === "STUDIO") {
        dispatchAction(
          fetchActiveAccountantService(auth, main.accountantSelected)
        );
        dispatchAction(allAgyoServicesSubscription(auth));
      }
      dispatchAction(
        getSettingsCompany()
      );
      dispatchAction(
        getSettingsCompanyForUser(
          main.companyUuidSelected,
          user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id,
          main.accountantUuidSelected
        )
      );
    }
  }, [main.accountantUuidSelected, main.companyUuidSelected,  user?.profile?.id, user?.profile?.uuid]);

  useEffect(() => {
    if (
      main.companiesRequestText === "" &&
      main.companiesRequestPage === 0
    )
      return;
    if (auth.loginAuth) {
      if (main.myType !== "STUDIO") getCompanies(main.myType);
      else {
        getCompanies(
          main.myType,
          studio,
          main.accountantIdSelected
        );
      }
    }
  }, [
    main.companiesRequestSize,
    main.companiesRequestPage,
    main.companiesRequestText
  ]);

  useEffect(() => {
    if (window.Cypress) { return }
    if (
      main.accountantUuidSelected !== "" &&
      main.companyUuidSelected !== "" &&
      // main.myType !== "STUDIO" &&
      FEATURE_TOGGLE_TSPAY === "true"
    ) {
      dispatchAction(
        loadConfig(
          auth,
          main.accountantUuidSelected,
          main.companyUuidSelected
        )
      ).then(res => {
        dispatchAction(
          loadAccounts(
            auth,
            main.accountantUuidSelected,
            main.companyUuidSelected
          )
        );
      });
      if (!window.Cypress) {
        dispatchAction(
          getTsPayConfigStatus(auth, main.companyUuidSelected)
        ).then(res => {
          dispatchAction(
            loadAccounts(
              auth,
              main.accountantUuidSelected,
              main.companyUuidSelected
            )
          );
        });
      }

    }
  }, [main.accountantUuidSelected, main.companyUuidSelected]);

  const changeFullTextSearch = value => {
    if (main.companiesRequestText !== "" && value === "") {
      dispatchAction({ type: "setFullTextSearch", searchTerm: value });
    }
    if (typeof value === "string" && value.length > 3) {
      /** Ad ogni nuova ricerca setto nuovamente page a 0 */
      if (
        main.companiesRequestText === "" ||
        main.companiesRequestText !== value
      )
        dispatchAction({
          type: "setNewPage",
          page: 0
        });
      dispatchAction({ type: "setFullTextSearch", searchTerm: value });
    }
  };

  const summonHeaderComponent = () => {
    const studioData = studio.list;
    let accountantUuidSelected;
    if (
      studioData !== undefined &&
      studioData !== null &&
      studioData.length > 0
    ) {
      accountantUuidSelected = studioData[0].uuid;
    }
    /**
   * BEGIN TODO: da rimuovere postDemo. Per capire se voglio o meno header e sidebar
   */
  const embedParameter = new URLSearchParams(location.search).get("embed");
  /**
   * END TODO: da rimuovere postDemo
   */

    return !main.isIntegrated && (
      <div>
        {main.myType && company.companies && embedParameter == null && location?.pathname !== "/choose-studio" && (
          <Header                                        
            changeFullTextSearch={changeFullTextSearch}                        
            openStudioModal={() => {
              studio.list.length > 1 && props.setVisibleStudioModal(true);
            }}
            pageCompanies={main.companiesRequestPage}
            searchTerm={main.companiesRequestText}                        
            setNewPageCompanies={e => {
              //setTimeout(() => {
              dispatchAction({
                type: "setNewPage",
                page: main.companiesRequestPage + 1
              });
              //  }, 200);
            }}           
          />
        )}
      </div>
    );
  };

  let checkTsPayCompleted = window.location.href.indexOf("/tspaycompleted") > 0;
  let checkTsPayConsentCompleted =
    window.location.href.indexOf("/tspayConsentsAccountsListCompleted") > 0;
  if (!checkTsPayConsentCompleted) {
    checkTsPayConsentCompleted =
      window.location.href.indexOf("/tspayConsentsRecurringCompleted") > 0;
  }

  return (
    
      <div>
        {window.UserVoice && user.profile && !main.isIntegrated && studioFind?.taxRegion !== "ES" && (
          <UserVoice
            user={user.profile ? user : null}
            userVoiceScript={window.UserVoice}
          />
        )}                     
        {auth.status.ended &&
          user.status.ended &&
          company.status.ended &&
          connection.status.ended &&
          main.accountantIdSelected === "" &&
          main.myType !== "STUDIO" && (
            <div
              style={{
                color: "#2A9DD6",
                fontSize: "24px",
                display: "flex",
                alignItems: "center",
                height: "100vh",
                justifyContent: "center"
              }}
            >
              <div>
                <div>
                  <FormattedMessage id="generic.selectStudio" />{" "}
                </div>
              </div>
            </div>
          )}

        { /*user.profile && */ (
          <>
            <div>{summonHeaderComponent()}</div>
            {auth.loginAuth &&
              company.status.ended &&
              company.companies.length === 0 &&
              !company.preSearchedCompany && (
                <MessageEmptyCompaniesStudio myType={main.myType} />
              )}                        
                <RoutesView                  
                  {...props}                                                                                    
                />
              
          </>
        )}
        <TimedOverflow />
      </div>
    
  );
};

export default Init;
